export const BRAND = {
  name: "Teresa Vilardo",
  role: "Family Coach Montessori",
  website: "https://www.teresavilardo.it",
  websiteLabel: "www.teresavilardo.it",
  email: "teresavilardoconsulente@gmail.com",
  whatsapp: "+39 340 399 3522",
  whatsappUrl: "https://wa.me/393403993522",
  instagram: "https://www.instagram.com/vilardo_teresa.infantcare?igsh=d3B2a2U4ZTljdzZ4",
  instagramLabel: "@vilardo_teresa.infantcare",
  logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/ovbpp0nb_logo%20cromie%20piene.png",
  photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/8v5x8osm_Logo%20sito%20teresa%20vilardo_20260220_092950_0002.png",
  photoChiSono: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/v3n5iypy_babysitter-bologna-castelmaggiore-bambini-montessori-teresa-vilardo-consulenze-1.webp",
  photos: {
    portrait: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/ximpoi4s_ChatGPT%20Image%203%20ago%202026%2C%2012_32_57.png",
    workingStudio: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/0kdi6f2l_ChatGPT%20Image%203%20ago%202026%2C%2012_33_05.png",
    withChild: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/x0pvkkx9_ChatGPT%20Image%203%20ago%202026%2C%2012_33_15.png",
    withChildAlt: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/82x2kp4b_ChatGPT%20Image%203%20ago%202026%2C%2012_33_22.png",
    casualWindow: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/cfafoqje_ChatGPT%20Image%203%20ago%202026%2C%2012_32_51.png",
    softNeutral: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/2kznvmz0_ChatGPT%20Image%203%20ago%202026%2C%2012_32_34.png",
    joyfulFloral: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/b7sn9ycq_ChatGPT%20Image%203%20ago%202026%2C%2012_32_40.png",
    warmStripes: "https://customer-assets-wrfwihn1.emergentagent.net/job_brand-vilardo/artifacts/g2tyt9gy_ChatGPT%20Image%203%20ago%202026%2C%2012_32_45.png",
  },
};

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Resolve an asset URL. If it starts with "/api/" (backend uploaded file),
// prepend the backend origin so <img> tags can load it. Other paths are
// returned as-is (they resolve against the frontend origin / public folder).
export function resolveAsset(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
